const getDeviceMemory = (): number | undefined => {
    if (!navigator.deviceMemory)
        return undefined;

    return parseFloat(navigator.deviceMemory as unknown as string);
}

export default getDeviceMemory;